<div *ngIf="!!config"
     class="form-group animated fadeIn">
    <label *ngIf="!!label">{{ label }}</label>
    <editor apiKey="{{apiKey}}"
            [formControl]="control"
            [init]="config"
            (onInit)="handleEditorInit($event)"></editor>
    <ng-content select="lf-control-messages"></ng-content>

    <input *ngIf="_uploader"
           #attachFile
           [uploader]="_uploader"
           class="custom-file-input"
           name="file"
           ng2FileSelect
           type="file"/>
</div>
